import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AudioRecorderChatEC } from '../audio-recorder';
import { Asr, AsrChat, ECAsrChat } from '../asr';
import { Translation, TranslationChat } from '../translation';
import ECChatReply from '../ec-chat-page/ECChatReply';
import { useSelector } from 'react-redux';
import DialPad from '../ec-chat-page/DialPad';



const CardChatECAgi = () => {
    const response = useSelector((state) => state.ecChat.response);
    const greeting = response === "" ? "ইলেকশন কমিশন চ্যাট বট এ আপনাকে স্বাগতম। কিভাবে আপনার সাহায্য করতে পারি?" : response;
    const dialPad = useSelector((state) => state.ecChat.dialPad);
    const [dialPadText, setDialPadText] = useState("");
    const dialPadTest = response === "" ? false : true;

    return (
        <Container style={{"background": "#f1f1f0"}}>
            <Row>
                <Col>
                    <div className="card-default">
                        <div>
                            <AudioRecorderChatEC />
                            <h3>{greeting}</h3>
                            <ECAsrChat />
                            {dialPadTest && <DialPad />}
                            <ECChatReply />            
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default CardChatECAgi;